<template>
  <div>
    <p v-if="attachments.length === 0" class="text-center text-muted my-3">
      Aún no se han subido archivos
    </p>

    <template v-else>
      <p class="fs-14 font-weight-bold text-secondary mb-1">Archivos del chat</p>

      <div style="max-height: 220px; overflow-y: auto">
        <b-list-group flush>
          <b-list-group-item
            v-for="comment in attachments"
            :key="comment.id"
            class="d-flex align-items-center px-0 py-2"
          >
            <font-awesome-icon
              :icon="isDocument(comment) ? ['far', 'file-alt'] : ['far', 'image']"
              size="lg"
              fixed-width
              class="text-primary flex-shrink-0 mr-2"
            />

            <div class="flex-grow-1" style="min-width: 0">
              <div class="d-flex align-items-center justify-content-between">
                <b-link
                  class="fs-14 font-weight-bold text-clamp-1"
                  :title="attachmentName(comment)"
                  @click="$emit('open-attachment', comment)"
                >
                  {{ attachmentName(comment) }}
                </b-link>
                <b-badge
                  v-if="documentTags[comment.id]"
                  :variant="documentTags[comment.id].variant"
                  class="flex-shrink-0 ml-2"
                >
                  {{ documentTags[comment.id].label }} v{{ documentTags[comment.id].version }}
                </b-badge>
              </div>
              <small class="d-block text-muted text-clamp-1">
                {{ comment.user | concatName2 }}
                <template v-if="userRole(comment.user)"> · {{ userRole(comment.user) }}</template>
                · {{ comment.created_at | formatDateTime }}
              </small>
            </div>

            <b-spinner v-if="loadingAttachmentId === comment.id" small class="flex-shrink-0 ml-2" />
          </b-list-group-item>
        </b-list-group>
      </div>
    </template>
  </div>
</template>

<script>
import { buildDocumentTags } from '../../../sharedOptions/drawingRequestOptions'

export default {
  name: 'DrawingRequestShowAttachments',
  props: {
    drawingRequest: { type: Object, required: true },
    loadingAttachmentId: { type: Number, default: null }
  },
  computed: {
    attachments () {
      return (this.drawingRequest.comments || [])
        .filter(comment => this.isDocument(comment) || this.isPhoto(comment))
        .reverse()
    },
    documentTags () {
      return buildDocumentTags(this.drawingRequest.comments)
    }
  },
  methods: {
    isDocument (comment) {
      return !!(comment.document && comment.document.id)
    },
    isPhoto (comment) {
      return !!(comment.photo && comment.photo.id)
    },
    attachmentName (comment) {
      if (this.isDocument(comment)) return comment.document.name
      return comment.photo.caption || 'Imagen'
    },
    userRole (user) {
      if (!user) return null
      if (user.id === this.drawingRequest.drafter_id) return 'Dibujante'
      if (user.id === this.drawingRequest.approver_id) return 'Aprobador'
      if (user.id === this.drawingRequest.requester_id) return 'Solicitante'
      return 'externo'
    }
  }
}
</script>
